import { Skeleton } from "antd";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { TbArrowDown, TbArrowUp } from "react-icons/tb";
import Carrier from "@Components/Carrier/Carrier";
import { SorterButtonField } from "src/components/SortersBar/SorterButton";
import { computeHotelLabels, defaultRenderLabel, getActiveSorterLabel } from "../utils";

const SortersMob: FC<{
  dataGroups: Map<string, Map<number | string, any[]>>;
  sorters: any[];
  activeSorter: string;
  activeValue?: boolean;
  isLoading?: boolean;
  pointsFactor: number;
} & HTMLAttributes<HTMLDivElement>> = ({
  dataGroups,
  sorters,
  activeSorter,
  activeValue,
  isLoading,
  pointsFactor,
  className,
}) => {
  const { t } = useTranslation();

  const activeSorterConfig = sorters.find((sorter) => sorter.key === activeSorter);
  const activeLabel = getActiveSorterLabel(dataGroups, activeSorterConfig, !!activeValue, pointsFactor);

  return (
    <Carrier
      label={t("Hotels.listing.sortBy")}
      renderTrigger={({ open }) => (
        <div
          role="button"
          className={classNames("border-border-default flex w-full cursor-pointer flex-col items-start gap-1 rounded-md border p-2 text-start", className)}
          onClick={open}
        >
          <div className="text-font-active flex w-full items-center justify-between font-bold">
            <span>{t("Hotels.listing.sortLabel", { title: activeSorterConfig?.title })}</span>
            {activeValue ? <TbArrowUp className="text-lg" /> : <TbArrowDown className="text-lg" />}
          </div>
          <div className="h-4">{isLoading ? <Skeleton.Input active classNames={{ root: "h-4!", content: "h-full!" }} /> : activeLabel}</div>
        </div>
      )}
      renderSheet={({ close }) => (
        <div className="flex flex-col px-4 pb-4 gap-2">
          {sorters.map((sorter, index) => {
            const group = dataGroups.get(sorter.key);
            const labels = group?.size ? computeHotelLabels(group, sorter, pointsFactor) : { minLabel: null, maxLabel: null };

            return (
              <div
                key={sorter.key}
                className={classNames(
                  "border-border-default py-2",
                  index !== sorters.length - 1 && "border-b",
                  sorter.key === activeSorter && "text-font-active",
                )}
                onClick={close}
              >
                <SorterButtonField sorter={sorter} valuesMap={group} isLoading={isLoading} labels={labels} renderLabel={defaultRenderLabel} />
              </div>
            );
          })}
        </div>
      )}
    />
  );
};

export default SortersMob;
